import { Tabs } from "client/CommonComponents";
import AssetOrderDetailViewBreadcrumb from "../AssetOrderDetailView/AssetOrderDetailViewBreadcrumb"
import AssetOrderDetailView from "../AssetOrderDetailView";
import AssetFleetProcessing from "../../AssetFleetProcessing";
import AssetFleetProcessingBreadcrumb from "../../AssetFleetProcessing/AssetFleetProcessingBreadcrumb";
import { useSelector } from "react-redux";
import { CONSTANTS } from "client/utils/constants";
import { useEffect } from "react";
import ApprovalHistory from "../../ApprovalHistory";

const AssetOrderDetailViewMainContainer = (props:any) => {
  const {tab, setSelectedKey, tabSwitchClicked, setTabSwitchClicked} = props
    const { orderDetails, afeOrderByIdData }: any = useSelector((state: any) => ({
        orderDetails: state.TransferOrderReducer.transferOrderByIdData,
        afeOrderByIdData: state.TransferReducer.afeOrderByIdData
      }));

  const tabItems = [
    {
      itemKey: "requisition",
      headerText: "Order Details",
      content: <AssetOrderDetailView
        tab={tab}
        setSelectedKey={setSelectedKey}
        tabSwitchClicked={tabSwitchClicked}
        setTabSwitchClicked={setTabSwitchClicked}
      />
    }
  ];
  const showFleetProcessingScreen = ()=>{
    if (orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.FLEET_PROCESSING 
      || orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.COMPLETED 
      || orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.CANCELLED
      || afeOrderByIdData?.orderStatus === CONSTANTS?.ORDER_STATUS?.FLEET_PROCESSING
      || afeOrderByIdData?.orderStatus === CONSTANTS?.ORDER_STATUS?.COMPLETED
      || afeOrderByIdData?.orderStatus === CONSTANTS?.ORDER_STATUS?.CANCELLED
    ) {
      return true;
    }
    return false;
  };

  if (showFleetProcessingScreen()) {
    tabItems.push(
      {
        itemKey: "approvalHistory",
        headerText: "Approval History",
        content: <ApprovalHistory
          setSelectedKey={props.setSelectedKey}
          tab={tab}
          tabSwitchClicked={props.tabSwitchClicked}
          setTabSwitchClicked={props.setTabSwitchClicked}
        />
      },
      {
        itemKey: "fleet-processing",
        headerText: "Fleet Processing",
        content: <AssetFleetProcessing
          selectedKey={props?.selectedKey}
          setSelectedKey={props.setSelectedKey}
          tabSwitchClicked={props.tabSwitchClicked}
          setTabSwitchClicked={props.setTabSwitchClicked}
          setShowFleetBreadcrumb={props.setShowFleetBreadcrumb}
          tab={tab}
        />

      }
    )
  }

      useEffect(()=>{
        if(orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.FLEET_PROCESSING 
          || orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.COMPLETED 
          || afeOrderByIdData?.orderStatus === CONSTANTS?.ORDER_STATUS?.FLEET_PROCESSING 
          || afeOrderByIdData?.orderStatus === CONSTANTS?.ORDER_STATUS?.COMPLETED){
          props.setSelectedKey("fleet-processing")
          props.setShowFleetBreadcrumb(true)
        }
      }, [orderDetails?.orderStatus])  

    if(orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.PENDING_APPROVAL 
      || orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.REJECTED 
      || orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.RETURNED_TO_REQUESTOR 
      || orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.RETURNED 
      || orderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.DELETED
      || afeOrderByIdData?.orderStatus === CONSTANTS?.ORDER_STATUS?.PENDING_APPROVAL
      || afeOrderByIdData?.orderStatus === CONSTANTS?.ORDER_STATUS?.REJECTED
      || afeOrderByIdData?.orderStatus === CONSTANTS?.ORDER_STATUS?.RETURNED_TO_REQUESTOR
      || afeOrderByIdData?.orderStatus === CONSTANTS?.ORDER_STATUS?.RETURNED
      || afeOrderByIdData?.orderStatus === CONSTANTS?.ORDER_STATUS?.DELETED
    ){
      return <>
      <AssetOrderDetailViewBreadcrumb/>
      <AssetOrderDetailView/>
      </>
    }  
    
    return (
        <div className="fleetProcessing fleet-processing-asset mt-3 mt-md-0" ref={props.wrapperRef}>
         { !props?.showFleetBreadcrumb ? <AssetOrderDetailViewBreadcrumb/> : <AssetFleetProcessingBreadcrumb/>}
            <Tabs
                className={`custom-tab `}
                tabItems={tabItems}
                selectedKey={props?.selectedKey}
                handleLinkClick={props?.handleLinkClick}
             data-attribute="AssetOrderDetailViewMainContainer_Default_Tabs" />   
        </div>
    )
}

export default AssetOrderDetailViewMainContainer